import { asciiTextValidation } from 'framework/form';
import { ValidationSchema } from 'validation-schema-library';

const stakeholderValidation = {
  id: {
    type: 'string',
    required: false,
  },
  name: {
    type: 'string',
    required: true,
    errorMessage: 'Name is required',
    maxSize: 255,
    ...asciiTextValidation,
  },
  jobTitle: {
    type: 'string',
    required: true,
    errorMessage: 'Job Title is required',
    maxSize: 255,
    ...asciiTextValidation,
  },
  email: {
    type: 'string',
    email: true,
    maxSize: 255,
  },
  phone: {
    type: 'string',
    required: false,
    maxLength: 50,
  },
  note: {
    type: 'string',
    required: false,
    maxSize: 1000,
    ...asciiTextValidation,
  },
};

const stakeholdersArrayValidation: ValidationSchema = {
  stakeholders: {
    type: 'array',
    forEach: {
      type: 'object',
      _divisible: false,
      properties: stakeholderValidation,
    },
  },
};

export default stakeholdersArrayValidation;
